import styled from "@emotion/styled";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import {
  TbLayoutSidebarLeftExpand,
  TbLayoutSidebarRightExpand,
} from "react-icons/tb";
import { useRecoilValue } from "recoil";
import { FullScreenAtom } from "../atoms/FullScreenAtom";
import SideBar from "../components/SideBar";
import useMediaQuery from "../hook/useMediaQuery";

export const Wrapper = styled.div`
  max-height: 100vh;
  height: 100%;
  width: 100vw;

  display: flex;
  flex-direction: row;

  position: relative !important;
`;

export const Container = styled.div<{ fullscreen?: boolean }>`
  width: ${({ fullscreen }) => (!fullscreen ? "calc(100vw - 60px)" : "100vw")};
  height: 100%;
  max-height: 100vh;

  margin-left: ${({ fullscreen }) => (!fullscreen ? "60px" : "0")};

  @media screen and (max-width: 560px) {
    width: 100vw;

    margin-left: 0;
  }
`;

const IconButton = styled.div`
  min-width: 42px;
  max-width: 42px;
  min-height: 42px;
  max-height: 42px;

  flex-shrink: 0;

  display: flex;

  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 5px;
  border: 1px solid #dddddd;
  cursor: pointer;

  position: fixed;
  top: 20px;
  right: 25px;
  z-index: 999;

  svg {
    width: 20px;
    height: 20px;
    color: #555555;
  }
`;

interface Props {
  children: JSX.Element;
  topBar?: JSX.Element;
}

export default function Layout(props: Props): JSX.Element {
  const router = useRouter();
  const { children, topBar } = props;
  const fullscreen = useRecoilValue(FullScreenAtom);
  const isLargerThan560 = useMediaQuery("(min-width: 560px)");

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    if (isLargerThan560) {
      setIsSidebarOpen(true);
      return;
    }
    setIsSidebarOpen(false);
  }, [router.asPath, isLargerThan560]);

  return (
    <Wrapper>
      {!fullscreen && (
        <SideBar
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
        />
      )}
      {!isLargerThan560 && (
        <IconButton onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
          {isSidebarOpen ? (
            <TbLayoutSidebarRightExpand />
          ) : (
            <TbLayoutSidebarLeftExpand />
          )}
        </IconButton>
      )}
      <Container fullscreen={fullscreen}>{children}</Container>
    </Wrapper>
  );
}
